<template>
  <div
    id="m_quick_sidebar"
    class="m-quick-sidebar m-quick-sidebar--tabbed m-quick-sidebar--skin-light m-quick-sidebar--on"
  >
    <div class="m-quick-sidebar__content">
      <div
        class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-4 border-bottom"
      >
        <h1 class="h2">Lista de contratos</h1>
        <div class="btn-toolbar mb-2 mb-md-0">
          <fieldset
            class="btn-group btn-group-sm"
            aria-label="Menu dos contratos"
          >
            <legend></legend>
            <span
              class="btn btn-outline-brand mr-2"
              @click="reprocess"
              v-b-tooltip.hover
              title="Reenviar os contratos com status processando ou erro"
            >
              <i class="fas fa-sync-alt"></i>&nbsp; Reenviar não faturados
            </span>
          </fieldset>
        </div>
        <div>
          <span class="m-quick-sidebar__close mt-2" @click="closeThis()">
            <i class="fal fa-times-circle fa-lg"></i>
          </span>
        </div>
      </div>
      <div
        id="alert"
        class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
        :class="alert.color"
        role="alert"
        v-if="alert.message"
        ref="alert"
      >
        <button
          type="button"
          class="close"
          aria-label="Close"
          @click="alert.message = ''"
        ></button>
        <i :class="alert.icon"></i> &nbsp;<strong>{{ alert.message }}</strong
        ><br />
        {{ alert.reason }}
      </div>

      <div class="tab-content">
        <table
          class="table table-striped- table-bordered table-hover table-checkable"
        >
          <caption></caption>
          <thead>
            <tr>
              <th>ID Contrato</th>
              <th>ID Cliente</th>
              <th>Mês</th>
              <th>Última tentativa</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(contract, id) in showLogContract" :key="id">
              <td>
                {{ contract.contract_id }}
              </td>
              <td>
                {{ contract.customer_id }}
              </td>
              <td>
                {{ contract.billing_date }}
              </td>
              <td>
                {{ contract.updated_at | datetime }}
              </td>
              <td :class="'font-weight-bold status-' + contract.status">
                {{ getStatusText(contract.status) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin.js';
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageFormMixin],
  name: 'LogBillingContractsModal',

  data() {
    return {
      data: {
        billing_month: '',
        contracts: '',
        billing_history_id: '',
      },
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
    };
  },

  components: {},
  methods: {
    getStatusText(status) {
      const statusMap = {
        1: 'Processando',
        2: 'Faturado',
        3: 'Erro',
        4: 'Cliente Bloqueado',
      };
      return statusMap[status] || '-';
    },
    closeThis() {
      this.$emit('updateList');
      this.$store.state.showLogContract = null;
      this.$parent.callData();
    },
    reprocess() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: 'Enviando requisição...',
        reason: '',
      };

      this.selectContractsError();

      if (this.data.contracts == '') {
        this.logMessageFormFailed({
          data: {
            message: 'Todos os contratos já foram faturados',
          },
        });
        return false;
      }

      const url = `${baseApiUrl}/v1/invoice/process`;
      axios
        .post(url, this.data)
        .then((res) => {
          this.logMessageForm(res);
        })
        .catch((error) => {
          this.logMessageFormFailed(error.response);
        });
    },
    selectContractsError() {
      let contracts = this.showLogContract
        .filter((contract) => contract.status != 2)
        .map((contract) => {
          return contract.contract_id;
        })
        .join(',');

      this.data.contracts = contracts;
      this.data.billing_month = this.showLogContract[0].billing_date;
      this.data.billing_history_id = this.showLogContract[0].billing_history_id;
    },
  },
  computed: {
    showLogContract() {
      return this.$store.state.showLogContract;
    },
  },
};
</script>

<style scoped>
.status-1 {
  color: #7592ff;
}
.status-2 {
  color: #00d86b;
}
.status-3 {
  color: #ff7575;
}
</style>